import {Fragment, useState} from "react";
import {
    Box, Container,
    Divider, List, ListItemAvatar,
    ListItemText, ListItemButton,
    Backdrop, MenuItem,
    Stack,
    Popover,
    Avatar
} from "@mui/material";
import ApartmentIcon from '@mui/icons-material/Apartment';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import './objectsList.css';
import {NavLink, useLoaderData} from "react-router-dom";
//import { calendar_object } from '../../datasets/calendarobjects';
import MobileUpBar from "../../components/mobileUpBar";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import api from "../../hooks/useApi";
import PlaceholderedImage from "../../components/placeholderImage";
import PageTitle from "../../components/PageTitle";

export async function loader({request, params}) {
    const fetch_data = (await api.get('/api/hotel_obj/get/')).data;
    const calendar_object = fetch_data.data;
    //console.log(calendar_object)
    return {calendar_object}
}

export default function MobileList() {
    const {calendar_object} = useLoaderData();
    const [itemSelected, setItemSelected] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const handleListItemClick = (ev, index) => {
        setItemSelected(index);
        setMenuAnchorEl(ev.currentTarget);
    }
    const handleCloseBackdrop = () => {
        setItemSelected(null);
        setMenuAnchorEl(null);
    }
    return (
        <>
            <PageTitle title="Локації (мобільна версія)" />
            <Backdrop open={Boolean(menuAnchorEl)} onClick={handleCloseBackdrop}>
                <Popover
                    open={Boolean(menuAnchorEl)}
                    anchorEl={menuAnchorEl}
                    component={Box}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                backgroundColor: 'transparent', // Change the background color here
                                padding: '5px',
                            },
                        }
                    }}
                >

                    <Stack direction='row' spacing={1} style={{backgroundColor: 'transparent', padding: 5}}>
                        <MenuItem onClick={handleCloseBackdrop} style={{backgroundColor: 'white'}}>
                            закрити
                        </MenuItem>
                        {/*<NavLink to={`/mobile/objects/${itemSelected}/calendar`}>*/}
                        <NavLink to={`/object/${itemSelected}/calendar`}>
                            <MenuItem style={{backgroundColor: 'white'}}>
                                <DateRangeOutlinedIcon/>
                            </MenuItem>
                        </NavLink>
                        {/*<MenuItem style={{ backgroundColor: 'white' }}>*/}
                        {/*    <BedOutlinedIcon />*/}
                        {/*</MenuItem>*/}
                        <NavLink to={`/object/${itemSelected}/details`}>
                            <MenuItem style={{backgroundColor: 'white'}}>
                                <ListAltOutlinedIcon/>
                            </MenuItem>
                        </NavLink>
                        {/*<MenuItem style={{ backgroundColor: 'white' }}>*/}
                        {/*    <EditOutlinedIcon />*/}
                        {/*</MenuItem>*/}
                    </Stack>

                </Popover>
            </Backdrop>

            <MobileUpBar
                linkVisible={false}
                middleElement={<div>Ваші обʼєкти</div>}
            />
            <Box style={{position: 'relative'}}>
                <List>
                    {calendar_object.map((el, index) => (
                        <Fragment key={el.id}>
                            <ListItemButton onClick={(ev) => {
                                handleListItemClick(ev, el.id)
                            }} className={el.id === itemSelected ? 'selectedListItem' : ''}>
                                <ListItemAvatar>
                                    {el.image.length > 0 ? (<Avatar src={el.image} alt={el.name}/>) : (
                                        <Avatar>
                                            <ApartmentIcon/>
                                        </Avatar>
                                    )}
                                </ListItemAvatar>
                                <ListItemText>
                                    {el.name}
                                </ListItemText>
                            </ListItemButton>
                            <Divider orientation='horizontal'/>
                        </Fragment>
                    ))}
                </List>
                <Container maxWidth='md'>
                    <Fab color="primary"
                         component={NavLink}
                         to='/mobile/new-object'
                         aria-label="add"
                         sx={{
                             position: 'fixed',
                             bottom: 76,
                             right: 16,
                         }}>
                        <AddIcon/>
                    </Fab>
                </Container>

            </Box>
        </>
    );
}
